/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryResponse, UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupPathParams } from "../models/UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroup";

function getUsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupUrl(groupId: UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupPathParams["groupId"]) {
  const res = { method: 'GET', url: `/admin/group/${groupId}/permissions` as const }  
  return res
}

/**
 * @summary Get all permissions for a specific group
 * {@link /admin/group/:groupId/permissions}
 */
export async function usersAuthzAPIAdminPermissionsReadGetPermissionsOfGroup(groupId: UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupPathParams["groupId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getUsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupUrl(groupId).url.toString(), ... requestConfig })  
  return res.data
}